import { render, staticRenderFns } from "./ImagePick.vue?vue&type=template&id=5fcd138e&scoped=true&"
import script from "./ImagePick.vue?vue&type=script&lang=js&"
export * from "./ImagePick.vue?vue&type=script&lang=js&"
import style0 from "./ImagePick.vue?vue&type=style&index=0&id=5fcd138e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd138e",
  null
  
)

export default component.exports